import { useCallback, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export function useAnnouncer() {
  const location  = useLocation()
  const regionRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    let region = document.getElementById('nudge-announcer')
    if (!region) {
      region = document.createElement('div')
      region.id = 'nudge-announcer'
      region.setAttribute('aria-live', 'polite')
      region.setAttribute('aria-atomic', 'true')
      region.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;'
      document.body.appendChild(region)
    }
    regionRef.current = region as HTMLElement
    return () => { region?.remove() }
  }, [])

  // Announce route changes automatically
  useEffect(() => {
    const pageTitle = document.title || 'Nudge'
    announce(`Navigated to ${pageTitle}`)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  const announce = useCallback((message: string, priority: 'polite' | 'assertive' = 'polite') => {
    const region = regionRef.current
    if (!region) return
    region.setAttribute('aria-live', priority)
    region.textContent = ''
    requestAnimationFrame(() => { region.textContent = message })
  }, [])

  return { announce }
}
